import { Link } from "react-router-dom";

function isExternal(to) {
  return /^https?:\/\//.test(to);
}

export default function SubNavRow({ section, pathname, hash, activeTo }) {
  if (!section?.items?.length) {
    return null;
  }

  const currentHash = (hash || "").replace(/^#/, "");

  return (
    <div className="nav-subnav" aria-label={`${section.label} subnavigation`}>
      <div className="nav-subnav-inner">
        <div className="nav-subnav-label">{section.label}</div>
        <span className="nav-subnav-divider" aria-hidden="true" />
        <div className="nav-subnav-items">
          {section.items.map((item) => {
            const itemHash = item.to.includes("#") ? item.to.split("#")[1] : "";
            const itemPath = itemHash ? item.to.split("#")[0] : item.to;
            const Icon = item.icon;
            const active =
              activeTo === item.to ||
              (!activeTo && itemHash && pathname === itemPath && currentHash === itemHash) ||
              (!activeTo && !itemHash && pathname === itemPath);

            const className = `nav-subnav-item${active ? " active" : ""}`;
            const ariaCurrent = active ? "page" : undefined;

            if (isExternal(item.to)) {
              return (
                <a key={item.to} className={className} href={item.to} target="_blank" rel="noopener noreferrer" aria-current={ariaCurrent}>
                  {Icon ? <Icon className="nav-subnav-icon" size={13} strokeWidth={1.75} aria-hidden="true" /> : null}
                  {item.label}
                </a>
              );
            }

            return (
              <Link key={item.to} to={item.to} className={className} aria-current={ariaCurrent}>
                {Icon ? <Icon className="nav-subnav-icon" size={13} strokeWidth={1.75} aria-hidden="true" /> : null}
                {item.label}
              </Link>
            );
          })}
        </div>

        {section.storeLinks?.length ? (
          <>
            <span className="nav-subnav-divider" aria-hidden="true" />
            <div className="nav-subnav-items">
              {section.storeLinks.map((store) => (
                <a
                  key={store.key}
                  className="nav-subnav-item nav-subnav-store-item"
                  href={store.to}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className={`nav-subnav-store-logo nav-subnav-store-logo-${store.key}`}
                    src={store.logo}
                    alt=""
                    aria-hidden="true"
                  />
                  {store.label}
                </a>
              ))}
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
}
